<script>
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js";
import {watch} from "vue";
import {useProcessModelStore} from "@/stores/Boarding/ProcessModel.js";
import ProcessModelFilter from "@/views/Boarding/ProcessModel/Components/ProcessModelFilter.vue";
import axios from "axios";

export default {
    name: "ProcessModels",
    components: {ProcessModelFilter},
    setup() {
        const {
            loading,
            total,
            filter,
        } = useSharedData();

        const {transformFilterValues, formatedDate} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const processStore = useProcessModelStore();
        const securityStore = useSecurityStore();


        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "code",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                value: "name",
                sortable: true,
            },
            {
                text: $i18n.t("boarding.category"),
                align: "left",
                value: "category",
                sortable: true,
            },
            {
                text: $i18n.t("common.comment"),
                align: "left",
                value: "description",
                sortable: true,
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_BOARDING_PROCESS'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'boarding_process_models.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['DELETE_BOARDING_PROCESS'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'boarding_process_models.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/boardingProcessModels', {params: transformFilterValues(filter.value)}).then((response) => {
                processStore.setProcessModels(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "boarding_process_models.view", params: {id: item.id}});
        }

        watch(filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        return {
            processStore,
            securityStore,
            headers,
            actions,
            loading,
            total,
            filter,
            findAll,
            view,
            formatedDate,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.process_model')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['SAVE_BOARDING_PROCESS']"
                    @press="$router.push({name: 'boarding_process_models.add'})"
                />
            </template>
            <template v-slot:content>
                <v-container fluid>
                    <ProcessModelFilter :filter="filter"/>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="processStore.processModels"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:item.code="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:item.name="{ item }">
                        <w-inline-text :text="item.name"/>
                    </template>
                    <template v-slot:item.category="{ item }">
                        <w-chip color="teal" :text="item.category"/>
                    </template>

                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>